import React, { useEffect } from 'react'

import LoadingSettings from 'components_new/organisms/pageLoaders/LoadingSettings'

import AllocationKeysOrganism from 'components_new/organisms/AllocationKeys'
import SettingsTemplate from 'components_new/templates/SettingsTemplate'

import { useAllocationKeyActions } from 'redux/actions/AllocationKeys'
import { useRealEstateActions } from 'redux/actions/RealEstates'
import { useEconomySetActions } from 'redux/actions/EconomySets'

import { useAllocationKeysFetched } from 'redux/hooks/AllocationKeys'
import {
  useEconomySetsFetched,
  useShouldFetchEconomySets
} from 'redux/hooks/EconomySets'
import { useRealEstatesFetched } from 'redux/hooks/RealEstates'

const AllocationKeysPage = () => {
  const allocationKeysFetched = useAllocationKeysFetched()
  const economySetsFetched = useEconomySetsFetched()
  const shouldFetchEconomySets = useShouldFetchEconomySets()
  const realEstatesFetched = useRealEstatesFetched()

  const { tryGetAllAllocationKeys } = useAllocationKeyActions()
  const { tryGetAllEconomySets } = useEconomySetActions()
  const { tryGetAllRealEstates } = useRealEstateActions()

  useEffect(() => {
    if (!allocationKeysFetched) {
      tryGetAllAllocationKeys()
    }

    if (shouldFetchEconomySets) {
      tryGetAllEconomySets()
    }

    if (!realEstatesFetched) {
      tryGetAllRealEstates()
    }
  }, [])

  return (
    <SettingsTemplate>
      {realEstatesFetched && economySetsFetched && allocationKeysFetched ? (
        <AllocationKeysOrganism />
      ) : (
        <LoadingSettings />
      )}
    </SettingsTemplate>
  )
}

export default AllocationKeysPage
